/**
 * Maps a database table that references a `service_catalog` row to the page an
 * admin can use to review or remove those records. Used by the Services Trash
 * screen to turn a "still referenced by …" block into an actionable link, so an
 * admin knows exactly where the dependent records live.
 */
export interface ServiceDependencyLink {
  /** Human-readable name of the dependent record type. */
  label: string;
  /** Dashboard route where those records are managed. */
  path: string;
}

export const SERVICE_DEPENDENCY_LINKS: Record<string, ServiceDependencyLink> = {
  lab_orders: { label: 'Lab Orders', path: '/administration/orders' },
  radiology_orders: { label: 'Radiology Orders', path: '/administration/orders' },
  diagnostic_receipt_department_routing: { label: 'Diagnostic Orders', path: '/administration/orders' },
  diagnostic_tests: { label: 'Diagnostic Tests', path: '/administration/diagnostic-tests' },
  diagnostic_receipt_items: { label: 'Diagnostic Receipts', path: '/opd/diagnostic-receipts' },
  invoice_items: { label: 'Invoices', path: '/billing/invoices' },
  charge_events: { label: 'Top Sheet (charge events)', path: '/billing/top-sheet' },
  patient_ledger: { label: 'Patient Ledger', path: '/billing' },
  beds: { label: 'Beds', path: '/beds' },
};

/** Look up the management page for a referencing table, if we know one. */
export function getServiceDependencyLink(table?: string): ServiceDependencyLink | undefined {
  if (!table) return undefined;
  return SERVICE_DEPENDENCY_LINKS[table];
}

/** Fallback display name for a referencing table we have no explicit mapping for. */
export function humanizeTableName(table: string): string {
  return table
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
